<template>
    <div class="dashboard bookings sales">
        <div class="head">
            <div class="title">Ventas</div>
        </div>

        <div class="summary" v-if="totalPax > 0">
            <div class="item">
                <div class="count">{{ totalPax }}</div>
                <div class="name">Viajeros</div>
            </div>
            <div class="item">

                    <div class="count">{{ $n(totalRetail, 'currency') }}</div>
                    <span>Retail</span>
            </div>
            <div class="item">
                <div class="count">{{ $n(totalMargin, 'percent') }}</div>
                <div class="name">Margin</div>
            </div>
            <div class="item">
                <div class="line">
                    <!-- <span>Retail</span> -->
                <div class="name">Costo</div>
                    <!-- <div class="count">{{ $n(totalRetail, 'currency') }}</div> -->
                <div class="count">{{ $n(totalCost, 'currency') }}</div>
                </div>
                <div class="line">
                    <span>1% Retail</span>
                    <div class="count">{{ $n(totalPorcRetail, 'currency') }}</div>
                </div>
                <div class="line">
                    <span>Retail Real</span>
                    <div class="count">{{ $n(totalRetailReal, 'currency') }}</div>
                </div>
            </div>
        </div>

        <div class="box-white filter">
            <vs-collapse>
                <vs-collapse-item icon-arrow="expand_more">
                    <div slot="header">
                        Buscador
                    </div>
                    <div class="wrapper">
                        <div class="item">
                            <vs-input label="Referencia" v-model="reference"/>
                        </div>
                        <div class="item">
                            <div class="wrap">
                                <label for="">Fechas</label>
                                <vs-select  class="creSelect" v-model="typeDate">
                                    <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in filterDates" />
                                </vs-select>  
                            </div>
                            <input-date-picker v-model="date" :currentDate="date"></input-date-picker>                
                        </div>
                        <div class="item">
                            <label for="">Estado Reservación</label>
                            <multiselect v-model="stBookings" :options="bookStatus" :multiple="true" :max-height="160" placeholder="" 
                                :close-on-select="false" :clear-on-select="false" :preserve-search="false" label="DESCRIPTION" track-by="DESCRIPTION">
                                <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} estados seleccionados</span></template>
                            </multiselect>
                        </div>
                        <div class="item relative">
                            <div class='autocompleteel'> 
                                <div class="form-row">
                                    <vs-input type="text" label="Agencia" v-model="searchText" @keyup='loadSuggestions'/>
                                    <div class='suggestionlist' v-if="suggestiondata.length">
                                        <ul> 
                                            <li v-for='(item,index) in suggestiondata' @click='itemSelected(index)' :key="index">  {{ item.NAME }} </li> 
                                        </ul>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <label for="">Agente</label>
                            <multiselect v-model="vendors" :options="consultants" :multiple="true" :max-height="160" placeholder="" open-direction="top"
                                :close-on-select="false" :clear-on-select="false" :preserve-search="false" label="NAME" track-by="NAME">
                                <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} agentes seleccionados</span></template>
                            </multiselect>
                        </div>
                        <div class="item">
                            <branch-select @onBranch="onHandleBranch"></branch-select>
                        </div>
                        <div class="item">
                            <vs-button color="primary"  @click="search()" type="filled" icon="search"></vs-button>
                            <vs-button color="warning"  @click="reset()" type="border" icon="backspace" 
                                v-if="date != '' || reference != ''  || vendors.length > 0 || agencies.length > 0 || stBookings.length > 0"></vs-button>
                        </div>
                    </div>
                    <div class="tags">
                        <div class="wrapper-tags">
                            <template v-for="(item, idx) in agencies">
                                <vs-chip :key="idx" transparent color="primary" closable @click="removeAgency(item)">{{ item.NAME }}</vs-chip>
                            </template>
                        </div>
                    </div>
                </vs-collapse-item>
            </vs-collapse>
        </div>

        <div class="bookings-wrapper">
            <table-sales :items="sales"></table-sales>
            <!-- <pagination :total="totalPost" @handlePagination="handlePagination" :key="key"/> -->
        </div>

   

    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
// import pagination from '@/components/Pagination.vue'
import tableSales from '@/components/Tables/Sales.vue'
import inputDatePicker from '@/components/Inputs/input-date-range.vue'
import BookingService from '@/services/BookingService'
import CatalogService from '@/services/CatalogService'
// import modal from "@/components/Modals/Basic.vue";
const  { mapActions: mapAppSettingActions } = createNamespacedHelpers('appSetting')
import branchSelect from '../../components/branchSelect.vue'

export default {
    name: "BookingsView",
    components: {
        // pagination,
        // modal,
        tableSales,
        branchSelect,
        inputDatePicker
    },
    data () {
        return {
            sales: [],
            key: 1,
            branch: 1,
            totalPost: 26,
            date: "",
            value: "All",
            reference: "",
            modalShow: true,
            codeAccess: "",
            errorCode: false,
            status: "",
            disabled: false,
            stBookings: [],
            bookStatus: [],
            types: [],
            totalPax: 0,
            totalCost: 0,
            totalRetail: 0,
            totalPorcRetail: 0,
            totalRetailReal: 0,
            totalMargin: 0,
            vendors: [],
            agencies: [],
            dataAgencies: [
                {
                    code: "HELLO",
                    name: "Hello America"
                }
            ],
            consultants:[],
            searchText: "",
            suggestiondata:[],
            typeDate: 1,
            filterDates: [
                {
                    code: 1,
                    name: "Sell Date"
                },
                {
                    code: 2,
                    name: "Travel Date"
                }
            ]
        }
    },
    async created () {
     
        await this.getSales(); 
        await this.getBookingStatus();
        await this.getConsultants();
    },
    methods: {
        ...mapAppSettingActions(["LOADING_STATUS"]),
        onHandleBranch(response){
            this.branch = response
        },
        async getSales(){            
            this.LOADING_STATUS(true);
            let moment    = require('moment');
            let response = await BookingService.getSales({
                "begDate" : this.date != '' ? moment(this.date.start).format('YYYY-MM-DD') : "", //opcional
                "endDate" : this.date != '' ? moment(this.date.end).format('YYYY-MM-DD') : "",//opcional
                "reference" : this.reference, //opcional
                "agencies" :    this.agencies, //opcional
                "consultants" : this.vendors, //opcional
                "booking_status": this.stBookings,
                "typeDate": this.typeDate,
                branch: this.branch,
            });            
            if((response.status/100) == 2){
                this.sales = response.data
            } 
            let marginCounter = 0;
            this.totalPax    = 0;
            this.totalCost   = 0;
            this.totalPorcRetail = 0;
            this.totalRetailReal = 0;
            this.totalRetail = 0;
            this.totalMargin = 0;
            this.sales.forEach(sale => {
                this.totalPax    = this.totalPax  + sale.PAX;
                this.totalCost   = this.totalCost + sale.COST;
                this.totalPorcRetail = this.totalPorcRetail + sale.PORC_RETAIL,
                this.totalRetailReal = this.totalRetailReal + sale.RETAILREAL,
                this.totalRetail = this.totalRetail  + sale.RETAIL;
                this.totalMargin = this.totalMargin  + sale.MARGIN; 
                marginCounter++
            });           
            this.totalMargin = this.totalMargin / marginCounter;
            this.LOADING_STATUS(false);
        },
        async getBookingStatus(){1
            this.LOADING_STATUS(true);
            this.bookStatus = await CatalogService.getBookingStatus({});            
            this.LOADING_STATUS(false);
        },
        async getConsultants(){
            this.LOADING_STATUS(true);
            this.consultants = await CatalogService.getConsultants({});            
            this.LOADING_STATUS(false);
        },
        handlePagination (_paged) {
            this.filter.page = _paged    
            // this.retrieveProperties()
        },
        search() {
            this.getSales()
        },
        reset() {
            this.date = "";
            this.reference = "";
            this.agencies  = [];
            this.vendors   = [];
            this.stBookings = [];
            this.getSales();
        },
        async loadSuggestions(){
            this.suggestiondata = [];
            if(this.searchText != ''){
                let response = await CatalogService.getAgencies({ search: this.searchText});
                console.log('response', response)
                if((response.status/100) == 2){
                    this.suggestiondata = response.data
                }
            }
            // else{
            //     this.filter.supplierId = ""
            // }
        },
        itemSelected(index){
            // this.searchText = this.suggestiondata[index].NAME;
            if(this.agencies.findIndex(item => item.CODE == this.suggestiondata[index].CODE) < 0){
                this.agencies.push(this.suggestiondata[index])
            }
            this.searchText = ''
            this.suggestiondata = [];
        },
        removeAgency (item) {
            this.agencies.splice(this.agencies.indexOf(item), 1)
        },
    }
}
</script>